export default "__VITE_ASSET__a0578858__"